import { InjectionToken } from '@angular/core';

export const SPHERE_ENVIRONMENT_PRODUCTION = new InjectionToken<boolean>('SPHERE_ENVIRONMENT_PRODUCTION');
